function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillOpacity: 0.5,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.794 34.515c2.101 2.856 6.13 4.204 8.1 3.067l19.891-11.484c1.363-.787 1.723-2.813.976-5.556-.12-.441-.58-.704-1.02-.585-.44.12-.704.58-.584 1.02.578 2.12.293 3.39-.205 3.678-.88.508-3.543-1.138-5.705-4.883-2.162-3.744-2.256-6.874-1.376-7.382.52-.3 1.795.128 3.387 1.768.325.33.848.337 1.18.011.33-.326.337-.849.018-1.184-2.048-2.098-4.019-2.846-5.418-2.038l-19.89 11.484c-1.97 1.137-2.818 5.301-1.39 8.556l2.036 3.528zm-.06-4.968l17.85-10.305c.295-.17.682-.067.853.229.17.295.067.682-.229.853L11.36 30.63c-.296.171-.683.067-.854-.228-.17-.296-.074-.679.229-.854zm1.646 4.1c-.17-.296-.067-.683.23-.853l17.783-10.268c.296-.17.683-.067.854.229.17.296.067.682-.23.853L13.235 33.876c-.303.175-.683.067-.854-.229zm21.062-7.59l-17.82 10.288c-.296.17-.683.067-.854-.229-.17-.295-.067-.682.229-.853l17.82-10.288c.296-.171.682-.068.853.228.171.296.067.683-.228.854zm-4.789-9.26L10.581 27.23c-.296.17-.683.067-.854-.229-.17-.295-.067-.682.229-.853l18.073-10.434c.295-.171.682-.067.853.228.17.296.074.679-.229.854z",
  transform: "translate(-180 -1000) translate(172 990) translate(.5)"
})))));

var SvgRoller = function SvgRoller(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoller, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roller.9295f52e.svg";
export { ForwardRef as ReactComponent };